import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as CheckboxMui,
} from "@mui/material";
import { Text } from "@utils/helper";
import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { useSelector } from "noval";
import { forwardRef } from "react";

const Checkbox = forwardRef(
  (
    {
      name,
      checked,
      onChange,
      label,
      helperText,
      error,
      controlLabelClassName,
      checkedIcon,
      customLabel,
      classNameLabel,
      icon,
      changeCallback,
      alignItems = "start",
      ...controlProps
    },
    ref
  ) => {
    const { lang } = useTranslation();
    const screen = useSelector("screen");
    const isMobile = ["sm-phone", "phone"].includes(screen);
    return (
      <FormControl error={error} {...controlProps}>
        {customLabel ? (
          <Text
            fontType="Expo_sim"
            weight={500}
            className={buildClass(
              classNameLabel,
              "!text-[13px] md:!text-[16px]"
            )}
          >
            {customLabel}
          </Text>
        ) : null}
        <FormControlLabel
          control={
            <CheckboxMui
              checked={checked}
              onChange={(event) => {
                event.stopPropagation();
                changeCallback && changeCallback(event.target.checked);
                onChange(event.target.checked);
              }}
              name={name}
              icon={icon}
              checkedIcon={checkedIcon}
              sx={{
                "& .MuiSvgIcon-root": {
                  borderRadius: 50,
                },
              }}
            />
          }
          label={label}
          className={controlLabelClassName}
          sx={{
            alignItems: alignItems,
            "& .MuiFormControlLabel-label": {
              color: "#333333",
              fontSize: isMobile ? "13px" : "14px",
              fontWeight: "500",
              lineHeight: "19px",
            },
            margin: "0 !important",
          }}
        />
        <FormHelperText
          sx={{
            textAlign: lang === "ar" ? "right" : "left",
          }}
        >
          {helperText}
        </FormHelperText>
      </FormControl>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
